import { DataGrid } from '@twilio-paste/core/data-grid';

import { useAppsList } from '../../../modules/Apps';
import { CreateAppSettingsDrawer, EditAppSettingsDrawer } from '../AppSettingsForm';
import { AppSecretsDrawer } from '../AppSettingsForm/AppSecretsDrawer/AppSecretsDrawer';
import { ReadOnlyAppSettingsDrawer } from '../AppSettingsForm/ReadOnlyAppDrawer';

import { AppsTableContent } from './AppsTableContent';
import { useAppsTableContext } from './AppsTableContext';
import { AppsTableHeader } from './AppsTableHeader';

export function AppsTable() {
  const { data: apps = [], isLoading, isError } = useAppsList();
  const { createAppDrawerState, editAppDrawerState, editingApp, viewAppDrawerState, appSecrets } =
    useAppsTableContext();

  return (
    <>
      <DataGrid aria-label="Apps table">
        <AppsTableHeader />
        <AppsTableContent apps={apps} isLoading={isLoading} isError={isError} />
      </DataGrid>
      <CreateAppSettingsDrawer state={createAppDrawerState} />
      {editingApp && <EditAppSettingsDrawer state={editAppDrawerState} app={editingApp} />}
      {editingApp && <ReadOnlyAppSettingsDrawer state={viewAppDrawerState} app={editingApp} />}
      {appSecrets && (
        <AppSecretsDrawer
          apiPrimaryKey={appSecrets.apiPrimaryKey}
          apiSecondaryKey={appSecrets.apiSecondaryKey}
        />
      )}
    </>
  );
}
